import '.hv{border-radius:0.625rem 0 0 0.625rem;}.ssr-plugin'
import '.hw{border-block:var(--border-default);}.ssr-plugin'
import '.hx{border-left:var(--border-default);}.ssr-plugin'
import '.hy{border-right:0px;}.ssr-plugin'
import '.a6{padding:0px;}.ssr-plugin'
import '.aw{cursor:pointer;}.ssr-plugin'
import '.bm{background:none;}.ssr-plugin'
import '.hz{border-radius:0 0.625rem 0.625rem 0;}.ssr-plugin'
import '.i0{border-right:var(--border-default);}.ssr-plugin'
import '.i1{border-left:0px;}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'
import { InputField } from '../InputField'

export type AmountPickerProps = {
  label: string
  value: number
  setValue: React.Dispatch<React.SetStateAction<number>>
  min?: number
  max?: number
}

const commonStyles: Style = {
  width: '2.6875rem',
  height: '2.6875rem',
  display: 'flex',
  flex: '1',
  justifyContent: 'center',
  alignItems: 'center',
}

export const AmountPicker = ({
  value,
  label,
  min = 0,
  max = 10,
  setValue,
}: AmountPickerProps) => {
  const decrease = () => {
    if (value > min) {
      setValue((prev) => prev - 1)
    }
  }
  const increase = () => {
    if (value < max) {
      setValue((prev) => prev + 1)
    }
  }
  return (
    <InputField label={label}>
      <Row style={{ width: '8.0625rem' }} gap={0}>
        <styled.button className="hv hw hx hy a6 aw bm"
          onClick={decrease}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faMinus} />
        </styled.button>
        <Text.Medium
          style={{
            ...commonStyles,
            border: 'var(--border-default)',
            userSelect: 'none',
          }}
        >
          {value}
        </Text.Medium>
        <styled.button className="hz hw i0 i1 a6 aw bm"
          onClick={increase}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faPlus} />
        </styled.button>
      </Row>
    </InputField>
  )
}
